(function ($) {

    'use strict';

    var CheckPhoneExists = function (element, options) {
        this.$element = $(element);
        this.options = options;

        this.$form = this.$element.closest('form');
        this.pageContext = this.$element.data('checkPhoneExists');
        this.originalPhone = '';
    };

    CheckPhoneExists.DEFAULTS = {
        'messages': {
            'required': 'Campo obrigatório',
            'phone': {
                'invalid': 'Número de telefone inválido.',
                'exists': 'Este telefone já está cadastrado'
            }
        }
    };

    CheckPhoneExists.prototype.saveCachedPhone = function () {
        this.originalPhone = this.$element.val().replace(/\D/g, '');
    };

    CheckPhoneExists.prototype.validateType = function () {
        this.removeErrors();

        var phoneValue = this.$element.val().replace(/\D/g, '');
        if (phoneValue.length < 11) {
            this.addError(this.options.messages.phone.invalid);
            return false;
        }

        return true;
    };

    CheckPhoneExists.prototype.validateOnDatabase = function () {
        if (this.validateType() === false) return;

        this.$form.removeClass('is-phone-valid');

        var currentPhone = this.$element.val().replace(/\D/g, '');
        if (currentPhone === this.originalPhone) {
            return this.$form.addClass('is-phone-valid');
        }

        this.load();
    };

    CheckPhoneExists.prototype.load = function () {
        var params = {
            'phone': this.$element.val(),
            'page': this.pageContext
        };

        $.getJSON('/customer/account/CheckPhoneExist/', params, $.proxy(this, 'loaded'));
    };

    CheckPhoneExists.prototype.loaded = function (data) {
        if (data.response) {
            return this.addError(this.options.messages.phone.exists);
        }

        this.removeErrors();
        this.$form.addClass('is-phone-valid');
        this.$form.submit();
    };

    CheckPhoneExists.prototype.addError = function (message) {
        this.$form.removeClass('is-phone-valid');
        this.$element.removeClass('is-valid').addClass('is-invalid');
        window.ParsleyUI.addError(this.$element.parsley(), 'phone-exists', message);
    };

    CheckPhoneExists.prototype.removeErrors = function () {
        this.$element.removeClass('is-invalid');
        window.ParsleyUI.removeError(this.$element.parsley(), 'phone-exists');
    };

    $.fn.checkPhoneExists = function (option, args) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('dft.check-phone-exists');
            var options = $.extend({}, CheckPhoneExists.DEFAULTS, $this.data(), typeof option == 'object' && option);

            if (!data) $this.data('dft.check-phone-exists', (data = new CheckPhoneExists(this, options)));
            if (typeof option == 'string') data[option](args);
        });
    };

    $(document).on('blur', '[data-check-phone-exists]', function (e) {
        $(this).checkPhoneExists('validateType');
    });

    $(document).on('click', '#myaccount-submit-edit', function (e) {
        $('[data-check-phone-exists]').checkPhoneExists('validateOnDatabase');
    });

    $(document).ready(function (e) {
        $('[data-check-phone-exists]').checkPhoneExists('saveCachedPhone');
    });

})(jQuery);
